import React, { useState } from 'react';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { LineItem } from '@payer-admin-ui/api/src/orders/models/LineItem';
import { ItemType } from '@payer-admin-ui/api/src/invoices/models/ItemType';
import { StandardButton, StandardButtonType } from '@payer-admin-ui/components-v2/src/buttons/StandardButton';
import { BasicButton } from '@payer-admin-ui/components-v2/src/buttons/BasicButton';
import { Validators } from '@payer-admin-ui/components-v2/src/inputs/validation';
import { TextInput } from '../../Input/TextInput';

export type EditInfoRowModalProps = {
  infoLine?: string;
  onAddOrUpdateInfoRow: (lineItem: Omit<LineItem, 'position'>) => void;
  onClose: () => void;
};
const EditInfoRowModal = ({ infoLine, onAddOrUpdateInfoRow, onClose }: EditInfoRowModalProps) => {
  const { t } = useTranslation();
  const [description, setDescription] = useState<string | undefined>(infoLine);

  return (
    <Modal size="lg" isOpen={true} toggle={onClose}>
      <ModalHeader toggle={onClose}>{t('invoices.CreateInvoicePage.infoRowModal')}</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <TextInput
              title={t('invoices.fields.lineItem.fields.description')}
              value={description}
              setValue={input => setDescription(input || undefined)}
              validators={[Validators.notEmpty, Validators.length(0, 128)]}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <StandardButton type={StandardButtonType.CANCEL} onClick={onClose} />
        <BasicButton
          color="primary"
          onClick={() => {
            if (description) {
              onAddOrUpdateInfoRow({
                itemType: ItemType.INFOLINE,
                calculationMode: 'INC_VAT_ROUNDING_PER_ROW',
                description,
                // these numbers are not essential for info rows which is why they are just set to defaults
                articleNumber: '',
                quantity: 1,
                vatPercentage: 0,
                subtotalPrice: 0,
                subtotalVatAmount: 0,
              });
            }
          }}
          disabled={!description}
        >
          {t('components.buttons.continue')}
        </BasicButton>
      </ModalFooter>
    </Modal>
  );
};

export { EditInfoRowModal };
